import Dev from "@fae/source/models/dev/Dev.js"

const devtips = [
    {
        "label": "Camera",
        "description": "Pan the camera clicking and dragging the mousewheel, or with WASD on the keyboard.",
    },
    {
        "label": "Gather",
        "description": "Select all units from the same template by double-clicking on one of them!!",
    },
    {
        "label": "Stack",
        "description": "If two units are at the same exact position, we use unit.stack to determine who is rendered above or below the other.",
    },
    {
        "label": "HUD",
        "description": "You can add a custom HUD on top of everything else using stage.hud. This can be either a string, a jsx object, or a function that returns either a string or jsx object."
    },
    {
        "label": "Playtest",
        "description": "Add ?playtest to the start of your url to load the game from your last active savestate.",
    }
    // TODO: Add more devtips here!
]

// TODO: should this be in a model, not the data...?
export function getTodayDevTip() {
    if(Dev.DateOfLastDevTip == undefined) {
        Dev.DateOfLastDevTip = window.localStorage?.getItem("DateOfLastDevTip")
    }

    const MILLISECONDS_IN_A_DAY = 1000 * 60 * 60 * 24
    const MILLISECONDS_BETWEEN_UTC_AND_PST = 1000 * 60 * 60 * 8
    const TODAY = Math.floor((Date.now() - MILLISECONDS_BETWEEN_UTC_AND_PST) / MILLISECONDS_IN_A_DAY)
    const DAY_OF_LAST_DEV_TIP = Math.floor((Dev.DateOfLastDevTip - MILLISECONDS_BETWEEN_UTC_AND_PST) / MILLISECONDS_IN_A_DAY)
    const devtip = devtips[Math.floor(TODAY % devtips.length)]

    devtip.isActive = TODAY != DAY_OF_LAST_DEV_TIP

    return devtip
}
